import { z } from "zod";
import { apiGet } from "./client";

export const PostSummarySchema = z.object({
  id: z.string(),
  slug: z.string(),
  title: z.string(),
  summary: z.string().nullable(),
  published: z.boolean(),
  published_at: z.string().nullable(),
  tags: z.array(z.string()),
  legacy_wp_id: z.number().int().nullable(),
});
export type PostSummary = z.infer<typeof PostSummarySchema>;

export const PostSchema = PostSummarySchema.extend({
  content_html: z.string(),
});
export type Post = z.infer<typeof PostSchema>;

export const PostSummaryListSchema = z.array(PostSummarySchema);

export async function fetchPosts(published = true): Promise<PostSummary[]> {
  return apiGet(`/posts?published=${published}`, PostSummaryListSchema);
}

export async function fetchPost(slug: string): Promise<Post> {
  return apiGet(`/posts/${encodeURIComponent(slug)}`, PostSchema);
}
